export default __webpack_public_path__ + "static-map-backdrop-28c944988e861ec6000a34cce2c3ba72.jpg";